import {helpers} from 'vuelidate/lib/validators';

export default function greaterThan(minBoundary) {
    const min = +minBoundary;
    return (value) => {
        const val = +value;

        if (value) {
            return !isNaN(min) && !isNaN(val) && val > min;
        }
        return !helpers.req(value);
    };
}
